var map = {
	"./Edward.webp": 4866,
	"./albi.png": 6917,
	"./black-parade.jpg": 8676,
	"./bullseye.png": 1536,
	"./cassidy.png": 3899,
	"./ciri.webp": 4304,
	"./daredevil.jpg": 2745,
	"./kratos.png": 5211,
	"./lara.webp": 3423,
	"./magneto.webp": 5928,
	"./messmer.webp": 5703,
	"./nero.webp": 2047,
	"./nightwing.webp": 2770,
	"./pike.webp": 2742,
	"./storm.jpg": 3230,
	"./thing.png": 757,
	"./ultron.png": 9947,
	"./vergil.webp": 5582,
	"./wolverine.png": 1660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4814;